import React from 'react';
import { Link } from 'react-router-dom';
import ctaData from '../../data/cta.json';

export default function CTAOne() {
    return (
        <section className="bsides-cta-footer" style={{position:'relative',overflow:'hidden',}}>
            <style>{`
                .bsides-cta-footer {
                    background: var(--eventflow-black);
                    padding: 80px 0 100px;
                    position: relative;
                    overflow: hidden;
                    border-top: 1px solid rgba(255,255,255,0.05);
                }
                .bsides-cta-footer::before {
                    content: '';
                    position: absolute; inset: 0;
                    background:
                        radial-gradient(ellipse at 20% 50%, rgba(var(--eventflow-primary-rgb),0.1) 0%, transparent 55%),
                        radial-gradient(ellipse at 80% 50%, rgba(var(--eventflow-base-rgb),0.08) 0%, transparent 50%);
                    pointer-events: none;
                }

                .bcf-inner {
                    position: relative; z-index: 1;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 64px;
                    align-items: center;
                }

                /* left — newsletter */
                .bcf-nl__tag {
                    display: inline-flex; align-items: center; gap: 8px;
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 3px; text-transform: uppercase;
                    color: var(--eventflow-base); margin-bottom: 16px;
                }
                .bcf-nl__tag::before, .bcf-nl__tag::after {
                    content: ''; display: inline-block;
                    width: 24px; height: 1px;
                    background: var(--eventflow-base); opacity: 0.5;
                }
                .bcf-nl__title {
                    font-family: var(--eventflow-font);
                    font-size: 36px; font-weight: 900;
                    color: #fff; line-height: 1.1;
                    letter-spacing: -1px; margin-bottom: 12px;
                }
                .bcf-nl__title span {
                    background: linear-gradient(135deg, var(--eventflow-base) 0%, #ff4d9e 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .bcf-nl__desc {
                    font-family: var(--eventflow-font);
                    font-size: 14px; color: rgba(255,255,255,0.45);
                    line-height: 1.75; margin-bottom: 28px;
                    max-width: 420px;
                }
                .bcf-nl__form {
                    display: flex; gap: 10px; flex-wrap: wrap;
                }
                .bcf-nl__input {
                    flex: 1; min-width: 220px;
                    background: rgba(255,255,255,0.05);
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 50px; padding: 13px 22px;
                    font-family: var(--eventflow-font);
                    font-size: 14px; color: #fff;
                    outline: none;
                    transition: border-color 0.3s;
                }
                .bcf-nl__input::placeholder { color: rgba(255,255,255,0.28); }
                .bcf-nl__input:focus { border-color: rgba(var(--eventflow-base-rgb),0.5); }
                .bcf-nl__success {
                    display: flex; align-items: center; gap: 10px;
                    background: rgba(var(--eventflow-base-rgb),0.08);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    border-radius: 50px; padding: 12px 22px;
                    font-family: var(--eventflow-font);
                    font-size: 14px; color: rgba(255,255,255,0.7);
                }
                .bcf-nl__success i { color: var(--eventflow-base); }
                .bcf-nl__note {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.25);
                    margin-top: 12px;
                }

                /* right — quick links */
                .bcf-links__title {
                    font-family: var(--eventflow-font);
                    font-size: 13px; font-weight: 700;
                    letter-spacing: 2px; text-transform: uppercase;
                    color: rgba(255,255,255,0.3); margin-bottom: 20px;
                }
                .bcf-links__grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 12px;
                    margin-bottom: 36px;
                }
                .bcf-link {
                    display: flex; align-items: center; gap: 12px;
                    background: rgba(255,255,255,0.06);
                    border: 1px solid rgba(255,255,255,0.12);
                    border-radius: 12px; padding: 16px 18px;
                    text-decoration: none;
                    transition: background 0.25s ease, border-color 0.25s ease, transform 0.2s ease;
                }
                .bcf-link:hover {
                    background: rgba(255,255,255,0.14);
                    border-color: rgba(255,255,255,0.28);
                    transform: translateY(-2px);
                }
                .bcf-link__icon {
                    width: 36px; height: 36px; border-radius: 8px;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0; transition: background 0.25s;
                }
                .bcf-link:hover .bcf-link__icon { background: rgba(var(--eventflow-base-rgb),0.2); }
                .bcf-link__icon i { font-size: 14px; color: var(--eventflow-base); }
                .bcf-link__label {
                    font-family: var(--eventflow-font);
                    font-size: 14px; font-weight: 600;
                    color: rgba(255,255,255,0.75);
                    transition: color 0.2s ease;
                }
                .bcf-link:hover .bcf-link__label { color: #fff; }

                /* event date badge */
                .bcf-date {
                    display: flex; align-items: center; gap: 14px;
                    background: rgba(255,255,255,0.03);
                    border: 1px solid rgba(255,255,255,0.07);
                    border-radius: 12px; padding: 16px 20px;
                }
                .bcf-date__icon {
                    width: 44px; height: 44px; border-radius: 10px;
                    background: rgba(var(--eventflow-base-rgb),0.1);
                    border: 1px solid rgba(var(--eventflow-base-rgb),0.2);
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0;
                }
                .bcf-date__icon i { font-size: 18px; color: var(--eventflow-base); }
                .bcf-date__label {
                    font-family: var(--eventflow-font);
                    font-size: 11px; font-weight: 700;
                    letter-spacing: 2px; text-transform: uppercase;
                    color: rgba(255,255,255,0.3); margin-bottom: 3px;
                }
                .bcf-date__value {
                    font-family: var(--eventflow-font);
                    font-size: 16px; font-weight: 800;
                    color: #fff;
                }
                .bcf-date__sub {
                    font-family: var(--eventflow-font);
                    font-size: 12px; color: rgba(255,255,255,0.35);
                }

                @media (max-width: 991px) {
                    .bcf-inner { grid-template-columns: 1fr; gap: 48px; }
                }
                @media (max-width: 576px) {
                    .bcf-links__grid { grid-template-columns: 1fr; }
                    .bcf-nl__title { font-size: 28px; }
                }
            `}</style>

            <div className="container">
                <div className="bcf-inner">

                    {/* Newsletter */}
                    <div className="wow fadeInLeft" data-wow-delay="100ms">
                        <div className="bcf-nl__tag">{ctaData.newsletter.tag}</div>
                        <h2 className="bcf-nl__title">
                            {ctaData.newsletter.titleNormal} <span>{ctaData.newsletter.titleHighlight}</span><br />{ctaData.newsletter.titleBreak}
                        </h2>
                        <p className="bcf-nl__desc">
                            {ctaData.newsletter.description}
                        </p>
                        <a href={ctaData.newsletter.buttonLink} target="_blank" rel="noreferrer" className="thm-btn" style={{ textDecoration: 'none' }}>
                            {ctaData.newsletter.buttonText} <span className="icon-arrow-right" />
                        </a>
                        <p className="bcf-nl__note" style={{marginTop: '16px'}}>{ctaData.newsletter.note}</p>
                    </div>

                    {/* Quick links + date */}
                    <div className="wow fadeInRight" data-wow-delay="200ms">
                        <div className="bcf-links__title">{ctaData.quickLinks.title}</div>
                        <div className="bcf-links__grid">
                            {ctaData.quickLinks.links.map((l, i) => (
                                <Link to={l.href} className="bcf-link" key={i}>
                                    <div className="bcf-link__icon"><i className={`fa ${l.icon}`} /></div>
                                    <span className="bcf-link__label">{l.label}</span>
                                </Link>
                            ))}
                        </div>
                        <div className="bcf-date">
                            <div className="bcf-date__icon"><i className={`fa ${ctaData.eventDate.icon}`} /></div>
                            <div>
                                <div className="bcf-date__label">{ctaData.eventDate.label}</div>
                                <div className="bcf-date__value">{ctaData.eventDate.value}</div>
                                <div className="bcf-date__sub">{ctaData.eventDate.location}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}


